import script from "./CrudTiposEvento.vue?vue&type=script&setup=true&lang=js"
export * from "./CrudTiposEvento.vue?vue&type=script&setup=true&lang=js"

import "./CrudTiposEvento.vue?vue&type=style&index=0&id=15228ce4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15228ce4"]])

export default __exports__